<template>
  <div
    class="category-legend"
    :style="{ 'max-width': clientWidth - 70 + 'px' }"
  >
    <div
      v-for="(item, key) in legendItemsActive"
      :key="key"
      class="legend-item"
    >
      <div
        :style="{
          backgroundColor: item.color,
          width: `${squareSize}px`,
          height: `${squareSize}px`,
        }"
        class="legend-rect"
      />

      <span class="legend-text">
        {{ item.name }}
      </span>
    </div>

    <div v-if="showNa" class="legend-item show-na">
      <div
        :style="{ width: `${squareSize}px`, height: `${squareSize / 2 + 1}px` }"
        class="legend-dotted"
      />

      <span class="legend-text"> Awaiting Data </span>
    </div>
  </div>
</template>

<script>
import { sortLegendKeys } from '@/analytics/helpers'

// Component for D3 Legend
export default {
  name: 'CategoryLegend',
  props: {
    items: {
      type: Object,
      required: true,
    },
    itemsActive: {
      type: Object,
      required: true,
    },
    clientWidth: {
      type: Number,
      default: null,
    },
    showNa: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      squareSize: 8,
    }
  },
  computed: {
    legendItemsActive() {
      const keys = Object.keys(this.itemsActive)
        .filter(x => {
          console.log('filter', x, this.items[x])
          return !!this.items[x]
    })
        .sort(sortLegendKeys)
        .reduce((obj, key) => ({ ...obj, [key]: this.items[key] }), {})
      console.log(keys)
      return keys
    },
  },
}
</script>

<style lang="scss">
.category-legend {
  border: 1px solid #dfe2ee;
  border-radius: 2px;
  padding: 16px;
  display: inline-block;
}

.legend-item {
  float: left;
  margin-right: 20px;
  &:first-child {
    margin-left: 0;
  }
  .legend-rect {
    display: inline-block;
    margin-right: 5px;
    border-radius: 2px;
  }
  .legend-dotted {
    display: inline-block;
    margin-right: 5px;
    border-top: 2px dotted #8684a6;
  }
  .legend-text {
    font-size: 11px;
    color: #1f2638;
    font-family: 'GT Cinetype Mono', Helvetica, Roboto, Arial, sans-serif;
  }
}
</style>
